/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { OidcService } from '../../types/oidc-service'
import Claims from '../../types/claims'
import { BaseOidcService } from '../base-oidc/base-oidc-service'

export class DesktopWidgetOidcService extends BaseOidcService implements OidcService {
  private accessToken: string | null = null
  private claims: Claims | null = null
  
  public init = async (): Promise<void> => {
    return Promise.resolve()
  }

  public isAuthenticated = (): boolean => {
    return this.accessToken != null && this.claims != null
  }

  public checkSession = async (): Promise<boolean> => {
    // auth session relevance should be controlled by the desktop app
    return Promise.resolve(true);
  }

  public getAccessToken = async (): Promise<string | null> => {
    return Promise.resolve(this.accessToken)
  }

  public setAccessToken = (value: string) => {
    this.accessToken = value
  }

  public getClaims = async (): Promise<Claims> => {
    return this.claims ? Promise.resolve(this.claims) : Promise.reject('No claims found');
  }

  public setClaims = (value: Claims) => {
    this.claims = value
  }

  public signinRedirect = async (): Promise<void> => {
    throw new Error("The method is not implemented.");
  }

  public logout = async (): Promise<void> => {
    this.clearAuthSession()
  }
  
  public signinRedirectCallback = (): Promise<void> => {
    // proxy flow has no signin redirect callback
    throw new Error("The method is not implemented.");
  }

  public onLogout(handler: () => void) {
    this.clearAuthSession()
    if(this.logoutHandler)
      this.logoutHandler()
  }

  private clearAuthSession = () => {
    this.accessToken = null
    this.claims = null
  }
}
